<template>
  <div class="breadcrumb-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item 
        v-for="(route, index) in routes" 
        :key="index"
        :to="index === routes.length - 1 ? undefined : route.path"
      >
        {{ route.meta?.title || route.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script setup lang="ts">
interface Route {
  path: string
  name?: string
  meta?: {
    title?: string
  }
}

interface Props {
  routes: Route[]
}

const props = defineProps<Props>()
</script>

<style lang="scss" scoped>
.breadcrumb-container {
  padding: 8px 16px;
  border-bottom: 1px solid #f0f0f0;
  margin: 0;
  background: white;
}
</style> 